import React, { useState, useRef, useEffect } from 'react'
import DataServices from '../../../Services/DataServices'
import IntlMessages from '../../../util/IntlMessages'
import {
  Table,
  Card,
  Col,
  Row,
  Button,
  Collapse,
  Tabs,
  Form,
  message,
  Spin,
  Tooltip,
  Tag
} from 'antd'
import Skeleton from 'react-loading-skeleton'
import { useHistory, useRouteMatch } from 'react-router'
import ds from '../../../Services/DataServices'
import { useDispatch } from 'react-redux'
import Icon, { ArrowLeftOutlined, InfoCircleFilled } from '@ant-design/icons'
import { userLogOut } from '../../../appRedux/actions'
import { INVENTORY_SCREEN } from '../../../constants/Pages'
import { setCommonConfigs } from '../../../appRedux/actions/CommonData'
import { useSelector } from 'react-redux'
import {
  getDecryptID,
  isEmptyObject,
  checkRightspermissions,
  notAllowMsgCheck,
  getRandomInt,
  formatDigits,
  checkExpiresSub,
  verifyPkgFeature
} from '../../../appRedux/actions/GlobalMethods'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import CustomScrollbars from '../../../util/CustomScrollbars'
import ExportReport from '../../../components/Reporting/ExportReport'
import NotAllowedComponent from '../../../components/NotAllowedComponent'
import { PkgFeatures } from '../../../constants/StoreEntities'

const { Column, ColumnGroup } = Table

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 }
  }
}
const InventoryCountItemDetailsReview = ({ match }) => {
  const Panel = Collapse.Panel
  const inventoryTakeID = match.params.id
  const isReviewPage = match.url.includes('review')

  const { TabPane } = Tabs
  const history = useHistory()
  const { path, url } = useRouteMatch()
  const data = []
  const [form] = Form.useForm()
  const dispatch = useDispatch()
  const tableRef = useRef(null)

  //#region useState
  const [options, setOptions] = useState([])
  const [getInventoryProductData, setInventoryProductData] = React.useState([])
  const [getSearchProd, setSearchProd] = useState([])
  const [getInventoryTakesData, setInventoryTakesData] = useState({})
  const [getInventoryTakesItemsData, setInventoryTakesItemsData] = useState([])
  const [getCurrData, setCurrData] = useState({
    currencyCode: '',
    currencyName: '',
    currencySymbol: ''
  })
  const [getMainLoader, setMainLoader] = useState(false)
  const [getSubLoader, setSubLoader] = useState(false)
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [getShortCurr, setShortCurr] = useState('')
  const [getCurrSymbol, setCurrSymbol] = useState('')
  const [getIsFilterLoading, setIsFilterLoading] = React.useState(true)
  const [getIsExportBtnShow, setIsExportBtnShow] = React.useState(false)
  const [activeKey, setActiveKey] = useState('5') // Initial active tab key
  const [isFeatureAllowed, setIsFeatureAllowed] = useState(true)
  const tabRef = useRef(null)

  //#endregion useState

  //#region useSelector
  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  const getDefaultDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  )
  //#endregion useSelector

  //#region useEffect

  useEffect(() => {
    if (tabRef.current) {
      debugger
      tabRef.current.click()
    }
  }, [activeKey])

  const handleTableRef = node => {
    tableRef.current = node
    // Now tableRef.current should be assigned with the DOM element
    console.log(tableRef.current)
  }

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (!verifyPkgFeature(PkgFeatures.InventoryManagement)) {
        setIsFeatureAllowed(false)
      }
      dispatch(setCommonConfigs(INVENTORY_SCREEN))
      let body = {
        BehaviorName: 1,
        InventoryTakeID: inventoryTakeID
      }

      getInventoryTakesandItemsData(body, PkgFeatures.InventoryManagement)
    }

    return () => (mounted = false)
  }, [])
  React.useEffect(() => {
    let mounted = true

    if (mounted) {
      const commonData = getReduxCommonSetting

      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}

      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrSymbol(currencyData.currencySymbol)
        setShortCurr(currencyData.currencyCode)
        setCurrData(currencyData)
      }

      // rights && permissions

      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)

        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)

          setAccessLoading(false)
        } else {
          toInitialState()

          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])
  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }

    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }

    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }

    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }

    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }

    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
  }

  function toInitialState () {
    setRights([])

    setPermissions([])

    setIsAllowRead(false)

    setIsDisableCreate(true)

    setIsDisableUpdate(true)

    setIsDisableDelete(true)

    setAccessLoading(true)
  }
  //#endregion useEffect

  //#region Api Services
  async function getInventoryTakesandItemsData (body, featureID) {
    setMainLoader(true)
    setSubLoader(true)

    const getInventoryData = ds.getInventoryTakesandItemsByID(
      body,
      BEHAVIOUR_TYPE.GET,
      featureID
    )
    await getInventoryData
      .then(response => {
        if (response) {
          let invTakesData = {
            InventoryTakeID: response.inventoryTakeID,
            InventoryName: response.inventoryName,
            OutletName: response.outletName,
            StatusName: response.statusName,
            ExecutedOn: response.executedOn,
            IsReview: response.isReview,
            TotalCostGain: response.totalCostGain,
            TotalCostLoss: response.totalCostLoss,
            TotalCountGain: response.totalCountGain,
            TotalCountLoss: response.totalCountLoss
          }

          setInventoryTakesData(invTakesData)
          setMainLoader(false)

          if (
            response.isReview &&
            response.inventoryTakesItems.length > 0 &&
            (response.statusName == 'In Progress' ||
              response.statusName == 'Completed' ||
              response.statusName == 'Canceled')
          ) {
            let invItemsData =
              response &&
              response.inventoryTakesItems.map(e => {
                return {
                  key: getRandomInt(100000000),
                  InventoryTakeItemID: e.inventoryTakeItemID,
                  InventoryTakeID: e.inventoryTakeID,
                  ProductID: e.productID,
                  ProductName: e.productName,
                  IsCounted: e.isCounted,
                  Counted: e.counted,
                  Expected: e.expected,
                  SKU: e.sku,
                  Cost: e.cost,
                  InventoryName: e.inventoryName,
                  IsMatched: e.isMatched,
                  CostDiff: e.costDiff,
                  UnitDiff: e.unitDiff
                }
              })
            setInventoryTakesItemsData(invItemsData)
            setSubLoader(false)
            setActiveKey('3')
            setActiveKey('5')
          }
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        setMainLoader(false)
        if (e.response && e.response.status === 401 && checkExpiresSub() > 0) {
          message.error('Token Expired! Redirecting to Login Page')
          setTimeout(() => {
            dispatch(userLogOut('store.getState()'))
          }, 3000)
        } else {
          message.error('Something Went Wrong...')
        }
      })
  }
  async function postInventoryStatusUpdate (body, featureID) {
    setMainLoader(true)
    setSubLoader(true)
    await ds
      .PostInventoryStatusUpdateDataService(
        body,
        BEHAVIOUR_TYPE.POST,
        featureID
      )
      .then(res => {
        if (res.data.data.isSaveUdate) {
          if (body.InventoryStatusType == 1) {
            message.success('Inventory Count Cancel')
            history.push('/Dashboard/inventory/inventorycount/listing')
          } else {
            history.push(
              `/Dashboard/inventory/inventorycount/${inventoryTakeID}`
            )
          }
          setMainLoader(false)
          setSubLoader(false)
          setActiveKey('3')
          setActiveKey('5')
        }
      })
      .catch(error => {
        notAllowMsgCheck(error)
        setMainLoader(false)
        setSubLoader(false)
        message.error('Something went wrong...')
      })
  }
  //#endregion Api Services

  //#region Change Functions, OnClick Form Save
  const handleInventoryStatusUpdate = inventoryStatusType => {
    //inventoryStatusType --> 1.Abandon ,2.Complete
    if (inventoryTakeID != '' && getInventoryTakesItemsData.length > 0) {
      let body = {
        BehaviorName: 3,
        InventoryTakeID: inventoryTakeID,
        InventoryStatusType: inventoryStatusType
      }
      postInventoryStatusUpdate(body, PkgFeatures.InventoryManagement)
    } else {
      history.push('/Dashboard/inventory/inventorycount/listing')
    }
  }
  const redirectToListing = () => {
    history.push('/Dashboard/inventory/inventorycount/listing')
  }
  //#endregion Change Functions, OnClick Form Save

  //#region Table Columns
  const columnsInventoryItem = [
    {
      title: (
        <IntlMessages id='products.inventoryCount.inventorycountitemdetailsreview.countlist' />
      ),
      key: 'CountList',
      dataIndex: 'CountList',
      children: [
        {
          title: (
            <IntlMessages id='products.inventoryCount.inventorycountitemdetails.produt' />
          ),
          key: 'ProductName',
          dataIndex: 'ProductName',
          render: (text, record) => (
            <>
              <div className='dk-table-tag'>
                <p>{text}</p>
                {!isReviewPage ? (
                  <div>
                    <Tag color='blue' key={`${text}`}>
                      <IntlMessages id='products.inventoryCount.inventorycountitemdetails.inventoryupdated' />
                    </Tag>
                  </div>
                ) : (
                  ''
                )}
              </div>
            </>
          )
        }
      ]
    },
    {
      title: (
        <IntlMessages id='products.inventoryCount.inventorycountitemdetailsreview.inventorycount' />
      ),
      key: 'InventoryCount',
      dataIndex: 'InventoryCount',
      children: [
        {
          title: (
            <IntlMessages id='products.inventoryCount.inventorycountitemdetails.expected' />
          ),
          key: 'Expected',
          dataIndex: 'Expected'
        },
        {
          title: (
            <IntlMessages id='products.inventoryCount.inventorycountitemdetailsreview.total' />
          ),
          key: 'Counted',
          dataIndex: 'Counted'
        }
      ]
    }
  ]
  const columnsInventoryItemAll = [
    {
      title: 'Count List',
      key: 'CountList',
      dataIndex: 'CountList',
      children: [
        {
          title: (
            <IntlMessages id='products.inventoryCount.inventorycountitemdetails.produt' />
          ),
          key: 'ProductName',
          dataIndex: 'ProductName',
          render: (text, record) => (
            <>
              <div className='dk-table-tag'>
                <p>{text}</p>
                {!isReviewPage ? (
                  <div>
                    <Tag color='blue' key={`${text}`}>
                      <IntlMessages id='products.inventoryCount.inventorycountitemdetails.inventoryupdated' />
                    </Tag>
                  </div>
                ) : (
                  ''
                )}
              </div>
            </>
          )
        }
      ]
    },
    {
      title: 'Inventory Count',
      key: 'InventoryCount',
      dataIndex: 'InventoryCount',
      children: [
        {
          title: (
            <IntlMessages id='products.inventoryCount.inventorycountitemdetails.expected' />
          ),
          key: 'Expected',
          dataIndex: 'Expected'
        },
        {
          title: 'Total',
          key: 'Counted',
          dataIndex: 'Counted'
        }
      ]
    },
    {
      title: 'Differences',
      key: 'Differences',
      dataIndex: 'Differences',
      children: [
        {
          title: 'Unit',
          key: 'UnitDiff',
          dataIndex: 'UnitDiff'
        },
        {
          title: 'Cost',
          key: 'CostDiff',
          dataIndex: 'CostDiff',
          render: (text, record) => (
            <span>{formatDigits(text, getDefaultDecimalPlaces)}</span>
          )
        }
      ]
    }
  ]

  //#endregion Table Columns
  //#region Components
  const InventoryFooterData = getInvTakesData => {
    debugger
    let tooltipData = [
      {
        Key: 1,
        Name: 'Gain',
        Count: getInvTakesData.TotalCountGain,
        Price: formatDigits(
          getInvTakesData.TotalCostGain,
          getDefaultDecimalPlaces
        )
      },
      {
        Key: 2,
        Name: 'Loss',
        Count: getInvTakesData.TotalCountLoss,
        Price: formatDigits(
          getInvTakesData.TotalCostLoss,
          getDefaultDecimalPlaces
        )
      }
    ]
    const columnsInvFooterToolTip = [
      {
        key: 'Name',
        dataIndex: 'Name'
      },
      {
        key: 'Count',
        dataIndex: 'Count'
      },
      {
        key: 'Price',
        dataIndex: 'Price'
      }
    ]
    return (
      <>
        <Row>
          <Col md={18}>
            <h2 className='custom-font-weight-500  custom-font-color-black'>
              <IntlMessages id='products.inventoryCount.inventorycountitemdetailsreview.total' />
            </h2>
          </Col>
          <Col md={6}>
            <Row>
              <Col md={12}>
                <div className='dk-display-inline'>
                  <h3 className='custom-font-weight-500  custom-font-color-black'>
                    {' '}
                    {getInvTakesData.TotalCountGain +
                      getInvTakesData.TotalCountLoss}{' '}
                  </h3>
                  <Tooltip
                    color={'#108ee9'}
                    title={
                      <Table
                        className='gx-table-responsive'
                        showHeader={false}
                        showFooter={false}
                        columns={columnsInvFooterToolTip}
                        dataSource={tooltipData}
                        pagination={false}
                      />
                    }
                  >
                    <InfoCircleFilled />
                  </Tooltip>
                </div>
              </Col>
              <Col md={12}>
                <h3 className='custom-font-weight-500  custom-font-color-black'>
                  {getCurrData.currencyCode != null
                    ? getCurrData.currencyCode
                    : getCurrData.currencyName != null
                    ? getCurrData.currencyName
                    : getCurrData.currencySymbol}{' '}
                  {formatDigits(
                    parseFloat(getInvTakesData.TotalCostGain) +
                      parseFloat(getInvTakesData.TotalCostLoss),
                    getDefaultDecimalPlaces
                  )}
                </h3>
              </Col>
            </Row>
          </Col>
        </Row>
      </>
    )
  }

  const InventoryFooterDataAll = props => {
    debugger
    const getInvTakesData = props.data
    let tooltipData = [
      {
        Key: 1,
        Name: 'Gain',
        Count: getInvTakesData.TotalCountGain,
        Price: formatDigits(
          getInvTakesData.TotalCostGain,
          getDefaultDecimalPlaces
        )
      },
      {
        Key: 2,
        Name: 'Loss',
        Count: getInvTakesData.TotalCountLoss,
        Price: formatDigits(
          getInvTakesData.TotalCostLoss,
          getDefaultDecimalPlaces
        )
      }
    ]
    const columnsInvFooterToolTip = [
      {
        key: 'Name',
        dataIndex: 'Name'
      },
      {
        key: 'Count',
        dataIndex: 'Count'
      },
      {
        key: 'Price',
        dataIndex: 'Price'
      }
    ]
    return (
      <>
        <Row>
          <Col md={18}>
            <h2 className='custom-font-weight-500  custom-font-color-black'>
              <IntlMessages id='products.inventoryCount.inventorycountitemdetailsreview.total' />
            </h2>
          </Col>
          <Col md={6}>
            <Row>
              <Col md={12}>
                <div className='dk-display-inline'>
                  <h3 className='custom-font-weight-500  custom-font-color-black'>
                    {' '}
                    {getInvTakesData.TotalCountGain +
                      getInvTakesData.TotalCountLoss}{' '}
                  </h3>
                  <Tooltip
                    className='total-tooltip'
                    title={
                      <Table
                        className='gx-table-responsive'
                        showHeader={false}
                        showFooter={false}
                        columns={columnsInvFooterToolTip}
                        dataSource={tooltipData}
                        pagination={false}
                      />
                    }
                  >
                    <InfoCircleFilled />
                  </Tooltip>
                </div>
              </Col>
              <Col md={12}>
                <h3 className='custom-font-weight-500  custom-font-color-black'>
                  {getCurrData.currencyCode != null
                    ? getCurrData.currencyCode
                    : getCurrData.currencyName != null
                    ? getCurrData.currencyName
                    : getCurrData.currencySymbol}{' '}
                  {formatDigits(
                    parseFloat(getInvTakesData.TotalCostGain) +
                      parseFloat(getInvTakesData.TotalCostLoss),
                    getDefaultDecimalPlaces
                  )}
                </h3>
              </Col>
            </Row>
          </Col>
        </Row>
      </>
    )
  }
  //#endregion components

  return (
    <>
      {getIsAllowRead && isFeatureAllowed ? (
        <Spin
          tip={<IntlMessages id='sell.cashlisting.cashloading' />}
          spinning={getMainLoader}
          size='large'
        >
          <div className='Content-wrapper inventory-Review'>
            <div className='back-arrow-h1'>
              <h1 className='d-flex align-items-center'>
                <ArrowLeftOutlined
                  className='dk-vertical-align'
                  onClick={redirectToListing}
                />
                <span className='mx-2'>
                  {' '}
                  {getInventoryTakesData.InventoryName}
                </span>
              </h1>
            </div>
            {isReviewPage ? (
              <Row className='ant-row dk-row-bg-color m-0 Sec-heading-bg'>
                <Col lg={12} md={24} sm={12} xs={24}>
                  <p className='title vd-hero-intro custom-font-color-black m-0'>
                    <IntlMessages id='products.inventoryCount.inventorycountitemdetailsreview.reviewanydiscrepancies' />
                  </p>
                </Col>

                <Col lg={12} md={24} sm={12} xs={24}>
                  <div className='pg-header-btn'>
                    {getSubLoader ? (
                      ''
                    ) : (
                      <Button
                        className='dk-btn-cancel'
                        type='primary'
                        size='large'
                        onClick={() => {
                          handleInventoryStatusUpdate(1)
                        }} //abandon
                      >
                        <IntlMessages id='products.inventoryCount.inventorycountitemdetailsreview.abandon' />
                      </Button>
                    )}

                    <Button
                      className='dk-btn-cancel'
                      type='primary'
                      size='large'
                      onClick={() => {
                        history.push(
                          `/Dashboard/inventory/inventorycount/${inventoryTakeID}/perform`
                        )
                      }}
                      disabled={getIsDisableDelete}
                    >
                      <IntlMessages id='products.inventoryCount.inventorycountitemdetailsreview.resume' />
                    </Button>

                    {getSubLoader ? (
                      ''
                    ) : (
                      <Button
                        className='dk-btn-add'
                        form='ProductForm'
                        htmlType='submit'
                        type='primary'
                        size='large'
                        onClick={() => {
                          handleInventoryStatusUpdate(2)
                        }} //complete
                        disabled={getIsDisableUpdate}
                      >
                        <IntlMessages id='products.inventoryCount.inventorycountitemdetailsreview.complete' />
                      </Button>
                    )}
                  </div>
                </Col>
              </Row>
            ) : (
              <Row className='ant-row dk-row-bg-color m-0 Sec-heading-bg'>
                <Col lg={12} md={24} sm={12} xs={24}>
                  <p className='title vd-hero-intro custom-font-color-black m-0'>
                    <IntlMessages id='products.inventoryCount.inventorycountitemdetailsfinal.viewandexport' />
                  </p>
                </Col>
                <Col lg={12} md={24} sm={12} xs={24}>
                  <div className='pg-header-btn'>
                    <ExportReport tableRef={tableRef} />
                  </div>
                </Col>
              </Row>
            )}

            <Card className='tab-body-parent mt-4'>
              {getSubLoader ? (
                <Skeleton count={7} height={35} />
              ) : (
                <Tabs
                  ref={tabRef}
                  defaultActiveKey={activeKey}
                  size='large'
                  onChange={setActiveKey}
                >
                  {isReviewPage ? (
                    <TabPane
                      tab={
                        <IntlMessages id='products.inventoryCount.inventorycountitemdetailsreview.uncounted' />
                      }
                      key='1'
                    >
                      <Card title=''>
                        {getSubLoader ? (
                          <Skeleton count={7} height={35} />
                        ) : (
                          <CustomScrollbars className='gx-layout-sider-scrollbar'>
                            <Table
                              className='gx-table-responsive'
                              columns={columnsInventoryItem}
                              dataSource={getInventoryTakesItemsData.filter(
                                x => x.IsCounted == false
                              )}
                              pagination={false}
                            />
                          </CustomScrollbars>
                        )}
                      </Card>
                    </TabPane>
                  ) : (
                    ''
                  )}

                  <TabPane
                    tab={
                      <IntlMessages id='products.inventoryCount.inventorycountitemdetailsreview.unmatched' />
                    }
                    key='2'
                  >
                    <Card title=''>
                      {getSubLoader ? (
                        <Skeleton count={7} height={35} />
                      ) : (
                        <CustomScrollbars className='gx-layout-sider-scrollbar'>
                          <Table
                            className='gx-table-responsive'
                            columns={columnsInventoryItemAll}
                            dataSource={getInventoryTakesItemsData.filter(
                              x => x.IsMatched == false
                            )}
                            footer={() =>
                              InventoryFooterData(getInventoryTakesData)
                            }
                            pagination={false}
                          />
                        </CustomScrollbars>
                      )}
                    </Card>
                  </TabPane>
                  <TabPane
                    tab={
                      <IntlMessages id='products.inventoryCount.inventorycountitemdetailsreview.matched' />
                    }
                    key='3'
                  >
                    <Card title=''>
                      {getSubLoader ? (
                        <Skeleton count={7} height={35} />
                      ) : (
                        <CustomScrollbars className='gx-layout-sider-scrollbar'>
                          <Table
                            className='gx-table-responsive'
                            columns={columnsInventoryItem}
                            dataSource={getInventoryTakesItemsData.filter(
                              x => x.IsMatched == true
                            )}
                            pagination={false}
                          />
                        </CustomScrollbars>
                      )}
                    </Card>
                  </TabPane>
                  {/* <TabPane
                    tab={
                      <IntlMessages id="products.inventoryCount.inventorycountitemdetailsreview.excluded" />
                    }
                    key="4"
                  >
                    <Card title="">
                      {getSubLoader ? (
                        <Skeleton count={7} height={35} />
                      ) : (
                        <Table
                          className="gx-table-responsive"
                          columns={columnsProductInventoryItemReview}
                          dataSource={dataProductInventoryItemReview}
                        />
                      )}
                    </Card>
                  </TabPane> */}
                  <TabPane
                    tab={
                      <IntlMessages id='products.inventoryCount.inventorycountitemdetailsreview.all' />
                    }
                    key='5'
                  >
                    <Card title=''>
                      {getSubLoader ? (
                        <Skeleton count={7} height={35} />
                      ) : (
                        <CustomScrollbars className='gx-layout-sider-scrollbar'>
                          {/* <Table
                            className="gx-table-responsive"
                            columns={columnsInventoryItemAll}
                            ref={tableRef}
                            dataSource={getInventoryTakesItemsData}
                            footer={() =>
                              InventoryFooterData(getInventoryTakesData)
                            }
                            pagination={false}
                          /> */}

                          <div className='ant-table'>
                            <div className='ant-table-container'>
                              <div className='ant-table-content'>
                                <table
                                  style={{ tableLayout: 'auto' }}
                                  ref={handleTableRef}
                                >
                                  {/* <table ref={node => tableRef.current = node}> */}
                                  <colgroup></colgroup>
                                  <thead className='ant-table-thead'>
                                    <tr>
                                      <th className='ant-table-cell'>
                                        Count List
                                      </th>
                                      <th
                                        colSpan='2'
                                        className='ant-table-cell'
                                      >
                                        Inventory Count
                                      </th>
                                      <th
                                        colSpan='2'
                                        className='ant-table-cell'
                                      >
                                        Differences
                                      </th>
                                    </tr>
                                    <tr>
                                      <th className='ant-table-cell'>
                                        Product
                                      </th>
                                      <th className='ant-table-cell'>
                                        Expected
                                      </th>
                                      <th className='ant-table-cell'>Total</th>
                                      <th className='ant-table-cell'>Unit</th>
                                      <th className='ant-table-cell'>Cost</th>
                                    </tr>
                                  </thead>
                                  <tbody className='ant-table-tbody'>
                                    {getInventoryTakesItemsData.map(
                                      (item, index) => (
                                        <tr
                                          key={index}
                                          className='ant-table-row ant-table-row-level-0'
                                        >
                                          <td className='ant-table-cell'>
                                            <div className='dk-table-tag'>
                                              <p>{item.ProductName}</p>
                                              {/* <div><span className="ant-tag ant-tag-blue">{item.text}</span></div> */}
                                              {!isReviewPage ? (
                                                <div>
                                                  <Tag
                                                    color='blue'
                                                    key={`${item.ProductName}`}
                                                  >
                                                    <IntlMessages id='products.inventoryCount.inventorycountitemdetails.inventoryupdated' />
                                                  </Tag>
                                                </div>
                                              ) : (
                                                ''
                                              )}
                                            </div>
                                          </td>
                                          <td className='ant-table-cell'>
                                            {item.Expected}
                                          </td>
                                          <td className='ant-table-cell'>
                                            {item.Counted}
                                          </td>
                                          <td className='ant-table-cell'>
                                            {item.UnitDiff}
                                          </td>
                                          <td className='ant-table-cell'>
                                            <span>{item.CostDiff}</span>
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>

                            <InventoryFooterDataAll
                              data={getInventoryTakesData}
                            />
                          </div>
                        </CustomScrollbars>
                      )}
                    </Card>
                  </TabPane>
                </Tabs>
              )}
            </Card>
          </div>
        </Spin>
      ) : (
        <NotAllowedComponent
          getAccessLoading={getAccessLoading}
          textType={!isFeatureAllowed ? 2 : 1}
        />
      )}
    </>
  )
}
export default InventoryCountItemDetailsReview
